const PAGE_TITLE = "Unsettled Sales";

export { PAGE_TITLE };
